<div class="container-fluid maap-root-container">
  <app-header></app-header>

  <div class="logs-page-content">
    <header class="standalone-page-header px-5">
      <h1 class="standalone-page-title">Logs Management</h1>
    </header>

    <div class="row">
       <div  class="col-md-12">
           <div  class="float-right row maap-right-controls">
               <div  class="col-md-6 mt-2"></div>
               <div  class="col-md-6"></div>
           </div>
       </div>
   </div>
   <div class="row">
     <div class="col-12">
       <div class="row p-5">
         <router-outlet></router-outlet>
         </div>
       </div>
     </div>
  </div>
</div>
